<template>
  <div>
    <v-select
      :items="items"
      item-title="className"
      item-value="classId"
      :model-value="modelValue"
      @update:model-value="updateValue"
      variant="outlined"
      density="compact"
      hide-details
      clearable
      color="primary"
    >
    </v-select>
  </div>
</template>

<script lang="ts">
import { NurseryClassResponse } from "chaild-api/lib";
import { defineComponent, PropType } from "vue";

export interface ClassSelectOption {
  classId: number | "all" | null;
  className: string;
}

export default defineComponent({
  name: "ClassPicker",

  emits: ["update:modelValue"],

  props: {
    classes: {
      type: Array as PropType<any[]>, 
      default: () => [],
    },
    modelValue: {
      type: [String, Number, null] as PropType<string | number | null>,
      default: null,
    },
    search: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    items(): ClassSelectOption[] {
      if (this.search) {
        return [
          // { classId: null, className: 'すべて' },
          { classId: "all", className: this.$t('pickers.all') as string },
          ...this.classes.map((c) => {
            return {
              classId: c.classId,
              className: `${c.year} ${this.$t('pickers.schoolYear')} ${c.className}`,
            };
          }),
        ];
      }
      return [
        ...this.classes.map((c) => {
          return {
            classId: c.classId,
            className: `${c.year} ${this.$t('pickers.schoolYear')} ${c.className}`,
          };
        }),
      ];
    },
  },

  methods: {
    updateValue(newValue: string | number | null) {
      this.$emit("update:modelValue", newValue);
    },
  },
});
</script>
